import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-db13ba14"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "w-100 image-input image-input-outline",
  "data-kt-image-input": "true",
  style: {"background-image":"url(media/avatars/blank.png)"}
}
const _hoisted_2 = { class: "d-flex p-2 justify-content-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "d-flex justify-content-center h-300px w-350px"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "mdi mdi-file-image" })
], -1))
const _hoisted_6 = { class: "text-center" }
const _hoisted_7 = ["title"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil-fill fs-7" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "hidden",
  name: "avatar_remove"
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x fs-2" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      class: _normalizeClass(["fs-6 fw-bold mb-2", { required: $props.required }])
    }, _toDisplayString($props.label), 3),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "dropzone",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.triggerUpload && $setup.triggerUpload(...args)))
      }, [
        ($props.src)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: $props.src,
              class: "img-fluid-kyc",
              alt: "passport preview"
            }, null, 8, _hoisted_3))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("p", _hoisted_6, _toDisplayString($props.label), 1)
            ]))
      ])
    ]),
    _createElementVNode("label", {
      class: "btn btn-icon btn-circle btn-active-color-primary bg-white shadow",
      "data-kt-image-input-action": "change",
      "data-bs-toggle": "tooltip",
      title: $props.label
    }, [
      _hoisted_8,
      _createElementVNode("input", {
        id: "uploader",
        ref: "uploader",
        name: "official_doc",
        type: "file",
        accept: ".png, .jpg, .jpeg",
        onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.changeImage && $setup.changeImage(...args)))
      }, null, 544),
      _hoisted_9
    ], 8, _hoisted_7),
    ($props.allowRemove)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: "btn btn-icon btn-circle btn-active-color-primary bg-white shadow",
          "data-kt-image-input-action": "remove",
          "data-bs-toggle": "tooltip",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.removeImage && $setup.removeImage(...args))),
          title: "Remove"
        }, _hoisted_11))
      : _createCommentVNode("", true)
  ]))
}